
export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const GET_TRANSACTION = 'GET_TRANSACTION'
export const ERROR_TRANSACTION = 'ERROR_TRANSACTION'
export const UPDATE_TRANSACTION ='UPDATE_TRANSACTION'